import { requestWithAuth } from '@/utilities/graphQLClient';
import { gql } from 'graphql-request';
import type { Portfolio } from '@/hooks/usePortfolio';

interface QueryResponse {
  renamePortfolio: boolean;
  errors: Error[];
}

export const renamePortfolioQueryFn = async (payload: {
  id: Portfolio['id'];
  name: Portfolio['name'];
}): Promise<boolean> => {
  const response = await requestWithAuth<QueryResponse>(
    gql`
      mutation renamePortfolio($id: String!, $newName: String!) {
        renamePortfolio(id: $id, newName: $newName) {
          id
          name
        }
      }
    `,
    {
      id: payload.id,
      newName: payload.name,
    }
  );
  const { renamePortfolio, errors } = response;
  if (errors && errors.length > 0) {
    throw new Error(errors[0].message);
  }
  return renamePortfolio;
};
